import $ from "jquery";
//logic for highlighting the nearest dropzone which falls inside y1 and y2
export function htmlElemsFallingBtwCords(selector, x1, y1, x2, y2, classOrId) {
    // console.log("selector::", classOrId,selector);
    var dropzones = selector.querySelectorAll(classOrId);

    if(dropzones.length>0){
        for (var i = 0; i < dropzones.length; i++) {
            // console.log('dropzones['+i+'] :: ',dropzones[i]);
            var $this = $(dropzones[i]);
            try{
                // console.log('dropzones[i] top:: ',dropzones[i].id,dropzones[i].getBoundingClientRect().top);
                var offset = $this.offset();
                // var x = offset.left;
                var dropzone_top = dropzones[i].getBoundingClientRect().top;
                // var w = $this.width();
                var hh = dropzones[i].offsetHeight;
                var dropzone_bottom = dropzones[i].getBoundingClientRect().bottom; //dropzone_top+hh;
                // console.log('dropzone_top, hh ,dropzone_bottom ::',dropzone_top,hh,dropzone_bottom);
                if(
                    (dropzone_bottom>=y1 && dropzone_bottom<=y2)
                    ||
                    (dropzone_top>=y1 && dropzone_top<=y2)
                ){
                    // console.log('found the dropzone!'+dropzones[i].id);
                    // console.log("dropzone_top::"+dropzone_top,"dropzone_bottom::"+dropzone_bottom);
                    // console.log('x1:'+x1,'y1:'+y1,'x2:'+x2,'y2:'+y2);
                    dropzones[i].classList.add("highlightedRow");
                    // console.log("adding dropzones[i]", dropzones[i]);
                    return dropzones[i];
                } else {
                    // console.log("dropzone_top::"+dropzone_top,"dropzone_bottom::"+dropzone_top);
                    // console.log('x1:'+x1,'y1:'+y1,'x2:'+x2,'y2:'+y2);
                    dropzones[i].classList.remove("highlightedRow");
                    // console.log("removing dropzones[i]", dropzones[i]);
                    // return false;
                }
            } catch(err){
                console.error(err);
            }
        }
    }
    // return false;
}